export const qestionsType={
    qcm:"QCM",
    rank:"Class",
    bool:"vraifaux",
    text:"libre"
}